import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/blog/why-csr-is-the-future-of-business/Business Impact Analysis Image.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/blog/why-csr-is-the-future-of-business/CSR-Mind-Map.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/blog/why-csr-is-the-future-of-business/laptop.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/blog/why-csr-is-the-future-of-business/Old-People-in-Factory.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/blog/why-csr-is-the-future-of-business/pilot.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/blog/why-csr-is-the-future-of-business/server.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/solutions/SolutionsCta.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/work/acquisition-network/hero.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/work/assured-book/hero.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/work/assured-book/jody-mack.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/work/assured-book/logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/work/regen-design-build/hero.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/work/regen-design-build/mark-hernandez.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/work/sams/after.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/work/sams/before.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/work/sams/hero.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/work/stigviewer/after.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/work/stigviewer/before.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/app/(site)/(marketing)/work/stigviewer/hero.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/components/backgrounds/Silk/Silk.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["BeforeAfterToggle"] */ "/vercel/path0/apps/lander/src/components/BeforeAfterToggle.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/lander/src/components/careers/ApplyForm.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScreenChat"] */ "/vercel/path0/apps/lander/src/components/careers/interview/ScreenChat.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["SchedulePanel"] */ "/vercel/path0/apps/lander/src/components/careers/SchedulePanel.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["CaseStudyHeroMedia"] */ "/vercel/path0/apps/lander/src/components/CaseStudyHeroMedia.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/components/FadeIn.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["FlipWords"] */ "/vercel/path0/apps/lander/src/components/FlipWords.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/lander/src/components/forms/PartnershipForm.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/components/GrayscaleTransitionImage.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/components/GridPattern.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/lander/src/components/JobAlertForm.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/components/magicui/shiny-button.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreakdownStack"] */ "/vercel/path0/apps/lander/src/components/pricing/BreakdownStack.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalculatorWizard"] */ "/vercel/path0/apps/lander/src/components/pricing/CalculatorWizard.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionGrid","SolutionCard"] */ "/vercel/path0/apps/lander/src/components/SolutionCard.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientIntakeForm"] */ "/vercel/path0/apps/lander/src/components/z2h/ClientIntakeForm.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrdIntakeChat"] */ "/vercel/path0/apps/lander/src/components/z2h/PrdIntakeChat.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrdIntakeReview"] */ "/vercel/path0/apps/lander/src/components/z2h/PrdIntakeReview.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/clients/acquisition-network/aqn-logo-long-dark.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/clients/greenlight-go/glg-dark-text.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/clients/jody-mack/author.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/clients/jody-mack/jm-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/clients/jody-mack/jody-mack-author.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/clients/millstone-forge-inc/mfi-logo-dark.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/clients/moxywolf/logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/clients/regen-design-build/regen-design-build-logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/clients/regen-design-build/regendb-logo-long.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/clients/sams/sams-logo.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/clients/shopify-partner/shopify-white-partners.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/clients/stigviewer/logo.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/kk_logo_gold.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/laptop.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/meeting.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/alec-mingione.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/alexis-lebron.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/angela-fisher.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/benjamin-russel.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/blake-reid.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/brian-meece.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/brittney-carter.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/chelsea-hagon.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/deshanell-kerr.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/dries-vincent.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/emma-dorsey.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/endeah-canty.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/jeffrey-webb.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/john-boese.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/kathryn-murphy.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/leonard-krasner.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/michael-foster.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/tavarse-green.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/team/whitney-francis.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lander/src/images/whiteboard.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/vercel/path0/node_modules/.pnpm/@iconify+react@5.2.1_react@19.2.7/node_modules/@iconify/react/dist/iconify.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.10_@babel+core@7.27.1_@opentelemetry+api@1.9.0_@playwright+test@1.54.1_react-_8dcd915e972dc0355f470e2078e8ebb8/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.10_@babel+core@7.27.1_@opentelemetry+api@1.9.0_@playwright+test@1.54.1_react-_8dcd915e972dc0355f470e2078e8ebb8/node_modules/next/dist/client/image-component.js");
